import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-qavisitreport",
  templateUrl: "./qavisitreport.component.html",
  styleUrls: ["./qavisitreport.component.scss"],
})
export class QavisitreportComponent implements OnInit {
  title: string = "تقارير الجودة المكتملة";
  isReviewed: boolean = true;
  hideActions: boolean = false;
  constructor() {}

  ngOnInit() {}
}
